/**
 * JWT utilities for access token parsing
 * Adapted from @chegg/utils/getUserUuid.ts
 */ import { getAccessTokenCookie } from '@chegg/utils';
/**
 * Parse a JWT token and return the payload
 * Adapted from isoParseIdTokenJWT in @chegg/utils
 * Handles both browser and Node.js environments
 */ export function parseJWT(token) {
    try {
        const base64Url = token.split('.')[1];
        if (!base64Url) return null;
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        if (typeof window !== 'undefined') {
            // Browser environment
            return JSON.parse(window.atob(base64));
        } else {
            // Node.js environment
            return JSON.parse(Buffer.from(base64, 'base64').toString());
        }
    } catch (error) {
        console.error('Error parsing JWT token:', error);
        return null;
    }
}
/**
 * Get and parse the access token from cookies
 * Returns the parsed payload or null if token is invalid/missing
 */ export function getAccessTokenPayload() {
    try {
        const accessToken = getAccessTokenCookie();
        if (!accessToken) {
            return null;
        }
        return parseJWT(accessToken);
    } catch (error) {
        console.error('Error getting access token payload:', error);
        return null;
    }
}
